export default {
    getCurrentGeolocationBrowser(updateGeolocationBrowser) {
        try {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => { this.getCurrentPositionSuccessCallback(position, updateGeolocationBrowser) },
                    error => { this.getCurrentPositionErrorCallback(error, updateGeolocationBrowser) },
                    {
                        timeout: 3000
                    }
                );
            } else {
                // updateGeolocationBrowser(null);
                console.debug("getCurrentGeolocationBrowser - navigator.geolocation is null");
            }
        } catch (ex) {
            // updateGeolocationBrowser(null);
            console.debug("getCurrentGeolocationBrowser exception", ex);
        }
    },
    getCurrentPositionSuccessCallback(position, updateGeolocationBrowser) {
        try {
            // const hbplGeolocationRange = {
            //     longMin: 103.823105,
            //     longMax: 103.823634,
            //     latMin: 1.263263,
            //     latMax: 1.264257
            // };

            let geolocationInfo = {
                longitude: position.coords.longitude,
                latitude: position.coords.latitude,
                accuracy: position.coords.accuracy
            };

            updateGeolocationBrowser(geolocationInfo);
            // console.debug("getCurrentPositionSuccessCallback", geolocationInfo);
        } catch (ex) {
            // updateGeolocationBrowser(null);
            console.debug("getCurrentPositionSuccessCallback exception", ex);
        }
    },
    getCurrentPositionErrorCallback(error, updateGeolocationBrowser) {
        try {
            let geoLocationError = null;
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    geoLocationError = "User denied the request for Geolocation.";
                    break;
                case error.POSITION_UNAVAILABLE:
                    geoLocationError = "Location information is unavailable.";
                    break;
                case error.TIMEOUT:
                    geoLocationError = "The request to get user location timed out.";
                    break;
                case error.UNKNOWN_ERROR:
                    geoLocationError = "An unknown error occurred.";
                    break;
            }
            console.debug("getCurrentPositionErrorCallback", geoLocationError);
        } catch (ex) {
            console.debug("getCurrentPositionErrorCallback exception", ex);
        }

        // updateGeolocationBrowser(null);
    },
    isInRange(longitude, latitude, geolocationInfo) {
        return geolocationInfo.some(x => {
            const finalMinLong = x.minLong - x.longTol;
            const finalMaxLong = x.maxLong + x.longTol;
            const finalMinLat = x.minLat - x.latTol;
            const finalMaxLat = x.maxLat + x.latTol;

            // console.debug("here", longitude, latitude)
            // console.debug("isInRange", finalMinLong, finalMaxLong, finalMinLat, finalMaxLat)

            if (longitude >= finalMinLong && longitude <= finalMaxLong && latitude >= finalMinLat && latitude <= finalMaxLat) {
                return true;
            }
        })
    }
}